
import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component
export default class ProgressbarStep extends Vue {

	@Prop()
	stepArr: []

	@Prop()
	now: 0


	progressbarListClass = (index: number): string => {
  switch (true) {
    case this.now == index + 1:
      return 'progressbar__list--active'
    case this.now > index + 1:
      return 'progressbar__list--complete'
    default:
      return ''
  }
}

}
